import {ACTION_CODE} from './_actionCode';
import {ProductionCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_PRODUCTIONCATEGORY';

export async function deleteProductionCategory(userData: Record<string, any>, productionCategoryId: number) {
    try {
        LoggerService.logInfo('Action - deleteProductionCategoryById - Start');

        const deleteProductionCategoryByIdResult = await ProductionCategoryService.deleteProductionCategory(userData, productionCategoryId);

        LoggerService.logInfo('Action - deleteProductionCategoryById - End - Success');

        return ResultModel.newSuccessResult(deleteProductionCategoryByIdResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - deleteProductionCategoryById - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
